import EmberTooltipComponent from 'ember-tooltips/components/ember-tooltip';

export default class EmberTooltip extends EmberTooltipComponent {
  popperContainer = 'body';
}
